// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__S5nPn","rootMobile":"styles_rootMobile__3Htn6"};